'use strict';

const { isFeatureEnabled, checkSetting } = require('../helpers/finch');
const { isInUS } = require('../helpers/division')

module.exports = class DealFetcher {
  constructor(baseUrl, defaultParams = {}) {
    this.baseUrl = baseUrl;
    this.defaultParams = defaultParams;
    this.cachedResponses = {};

    this.addPreloadNextPageScrollListener();
  }

  fetchDeals(currentParams) {
    this.requestUrl = this._generateUrl(currentParams);

    const cachedResponse = this._getCachedResponse(this.requestUrl);

    const _this = this;

    if (cachedResponse && this._checkFeatureIfInUS('showHomepageImmediatePagination')) {
      return Promise.resolve(cachedResponse);
    } else {
      return fetch(this.requestUrl, { credentials: 'include' })
        .then(function determineStatus(response) {
          if (response.status >= 200 && response.status < 300) {
            return Promise.resolve(response);
          } else {
            return Promise.reject(response);
          }
        })
        .then(function toJson(response) {
          return response.json();
        })
        .then(function addToCacheAndReturn(data) {
          _this.cachedResponses[_this.requestUrl] = data;
          return Promise.resolve(data);
        })
    }
  }

  _generateUrl(queryParams) {
    return this.baseUrl + '?' + $.param(queryParams);
  }

  _getCachedResponse(url) {
    return this.cachedResponses[url];
  }

  _hackCheckIfNextPageExists() {
    const paginationElement = document.querySelector('#pull-pagination');
    if (paginationElement && paginationElement.style.display != 'none') {
      const nextButton = paginationElement.querySelector('a.next[href]');

      if (nextButton)
        return true;
    }

    return false;
  }

  addPreloadNextPageScrollListener() {
    if (!isInUS() && !checkSetting('showHomepageImmediatePaginationInternational')) { return; }

    this._handlePreloadingDeals = () => {
      if ((window.scrollY / document.body.scrollHeight) > .35) {
        if (this._hackCheckIfNextPageExists()) {
          this.fetchDeals(this._getNextPageUrlParams());
        }
        return window.removeEventListener('scroll', this._handlePreloadingDealsDebounced);
      }
    };

    this._handlePreloadingDealsDebounced = _.debounce(this._handlePreloadingDeals, 250);
    return window.addEventListener('scroll', this._handlePreloadingDealsDebounced);
  }

  _getNextPageUrlParams() {
    var currentQueryParams = Groupon.Utils.unparam();

    const preloadNextPageParams = Object.assign({}, this.defaultParams, currentQueryParams);

    const preloadedNextPageNum = currentQueryParams.page != null ? (Number.parseInt(currentQueryParams.page) + 1).toString() : '2';
    preloadNextPageParams.page = preloadedNextPageNum;

    return preloadNextPageParams;
  }

  _checkFeatureIfInUS(setting) {
    if (isInUS()) {
      return isFeatureEnabled(setting);
    } else {
      return true;
    }
  }
};